import { shallowEqual, useSelector } from 'react-redux';
import { getPayoutFee } from '../selectors';

export const usePayoutFee = () => {
  const fee = useSelector(getPayoutFee, shallowEqual);
  return { fee };
};
